<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <rule-header :value="ruleHeader"/>
      <rule-game :title="ruleTitle.payRate" :value="rulePayrate"/>
      <rule-game :title="ruleTitle.rule" :value="ruleGame"/>
      <rule-game :title="ruleTitle.player" :value="rulePlayer"/>
      <rule-game :title="ruleTitle.counting" :value="ruleCounting"/>
    </div>
  </div>
</template>

<script>
import Board from '../../assets/gamerule/brp/Board-min.png';
import loseWin from '../../assets/gamerule/brp/Lose-win-min.png';
import coin from '../../assets/gamerule/brp/Coin-all-min.png';
import random from '../../assets/gamerule/brp/Random-and-Confirm-min.png';
import counting1 from '../../assets/gamerule/brp/Counting01-min.png';
import counting2 from '../../assets/gamerule/brp/Counting02-min.png';
import counting3 from '../../assets/gamerule/brp/Counting03-min.png';

export default {
  name: 'rule_brp',
  data() {
    return {
      ruleHeader: {
        gameName: 'เป่ายิงฉุบ (BR)',
        boardImg: Board,
      },
      ruleTitle: {
        payRate: 'อัตราจ่าย',
        rule: 'กติกา',
        player: 'ผู้เล่น',
        counting: 'การนับแต้ม',
      },
      rulePayrate: [
        {
          type: 'text',
          text: 'อัตราจ่าย 1:0.97 (หากผู้เล่นลงเดิมพัน 100 บาท และได้รับ ชัยชนะ ผู้เล่นจะได้รับเงินจากการเดิมพัน 97 บาท)',
          class: 'ml-3',
        },
      ],
      ruleGame: [
        {
          type: 'text',
          text: 'อัตราการเดิมพันต่อรอบจะเท่ากับจำนวนเดิมพัน หน้าห้องหนึ่งห้องจะมีผู้เล่นได้สูงสุด 6 คน สามารถเริ่มเล่นได้ ตั้งแต่  2 คน ขึ้นไปซึ่งกติกาการเล่นมีอยู่เพียงแค่ 3 ข้อ คือ ค้อนชนะกรรไกร กรรไกรชนะกระดาษ และกระดาษชนะค้อน ถ้าหากเสมอ ผู้เล่นจะไม่ได้ไม่เสีย',
          class: 'ml-3',
        },
        {
          type: 'imageNoborder',
          image: loseWin,
          class: 'w-25',
        },
      ],
      rulePlayer: [
        {
          type: 'text',
          text: 'เริ่มเกมส์ผู้เล่นจะต้องเลือก ค้อน กรรไกร กระดาษ โดยเลือกได้เเค่อันใดอันหนึ่ง',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: coin,
          class: 'w-50',
        },
        {
          type: 'text',
          text: 'หากกดปุ่มสุ่มจะสามารถสุ่มตัวเลือกได้ จากนั้นให้กดยืนยันเพื่อยืนยันคำตอบ',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: random,
          class: 'w-50',
        },
      ],
      ruleCounting: [
        {
          type: 'text',
          text: 'รูปแบบของการคิดเเต้ม คือการวัดแต้มของเรากับผู้เล่นอื่นทีละคน โดยวนจากซ้ายไปขวา เเล้วคิดยอดรวมแพ้ชนะ',
          class: 'ml-3',
        },
        {
          type: 'threeImage',
          image: counting1,
          class: 'w-90',
          image2: counting2,
          image3: counting3,
        },
      ],

    };
  },
};
</script>
